.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-3);
  max-width: 960px;
  margin: 0 auto;
}
